<ng-container *ngIf="currentFormPrompt$ | async as currentContext">
  <p-dialog [visible]="!!currentContext" [style]="{ minWidth: '200px', width: 'auto', minHeight: '200px' }" [closable]="false">
    <ng-template pTemplate="header">
      <div class="p-dialog-title">
        {{ 'unsavedChangesDialogComponent.msg.header' | translate
        }}{{ currentContext.formDisplayNameKey ? ': ' + (currentContext.formDisplayNameKey | translate) : '' }}
      </div>
    </ng-template>
    <div class="avano-unsaved-changes-dialog-content">
      <div class="avano-unsaved-changes-dialog-icon">
        <i class="icon-content-warning" title="Warning"></i>
      </div>
      <div class="avano-unsaved-changes-dialog-text">
        <div class="avano-unsaved-changes-dialog-text-title">
          {{
            (currentContext.saveSupported
              ? 'unsavedChangesDialogComponent.msg.canSave.contentTitle'
              : 'unsavedChangesDialogComponent.msg.noSave.contentTitle'
            ) | translate
          }}
        </div>
        <div class="avano-unsaved-changes-dialog-text-description">
          {{
            (currentContext.saveSupported
              ? 'unsavedChangesDialogComponent.msg.canSave.contentMessage'
              : 'unsavedChangesDialogComponent.msg.noSave.contentMessage'
            ) | translate
          }}
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <ng-container *ngTemplateOutlet="applyToAllCheckbox"></ng-container>
      <ng-container *ngTemplateOutlet="discardButton; context: { $implicit: currentContext }"></ng-container>
      <ng-container
        *ngTemplateOutlet="currentContext.saveSupported ? resumeButton : cancelButton; context: { $implicit: currentContext }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="currentContext.saveSupported && currentContext.canSave ? saveButton : errorButton; context: { $implicit: currentContext }"
      ></ng-container>
    </ng-template>
  </p-dialog>
</ng-container>

<!-- Templates -->
<ng-template #applyToAllCheckbox>
  <p-checkbox
    *ngIf="(unsavedForms$ | async).length > 1"
    [(ngModel)]="applyToAll"
    [label]="'unsavedChangesDialogComponent.msg.applyToAll' | translate"
    [style.marginRight]="'auto'"
    [binary]="true"
  >
  </p-checkbox>
</ng-template>

<ng-template #discardButton [typedTemplate]="contextType" let-currentContext>
  <button
    type="button"
    avanoButton
    [label]="'unsavedChangesDialogComponent.btn.discard' | translate"
    icon="icon-content-trash"
    (click)="discardChanges(currentContext.ref)"
  ></button>
</ng-template>

<ng-template #resumeButton [typedTemplate]="contextType" let-currentContext>
  <button
    type="button"
    avanoButton
    [label]="'unsavedChangesDialogComponent.btn.resume' | translate"
    icon="icon-content-back"
    (click)="resumeEditing(currentContext.ref)"
  ></button>
</ng-template>

<ng-template #cancelButton [typedTemplate]="contextType" let-currentContext>
  <button
    type="button"
    avanoButton
    [buttonType]="validationErrors?.length > 0 ? undefined : 'callToAction'"
    [label]="'unsavedChangesDialogComponent.btn.cancel' | translate"
    icon="icon-content-close"
    (click)="resumeEditing(currentContext.ref)"
  ></button>
</ng-template>

<ng-template #saveButton [typedTemplate]="contextType" let-currentContext>
  <button
    type="button"
    avanoButton
    [buttonType]="'callToAction'"
    [label]="'unsavedChangesDialogComponent.btn.save' | translate"
    icon="icon-content-save"
    (click)="saveChanges(currentContext.ref)"
  ></button>
</ng-template>

<ng-template #errorButton [typedTemplate]="contextType" let-currentContext>
  <button
    *ngIf="validationErrors?.length > 0"
    type="button"
    avanoButton
    icon="icon-content-error"
    [label]="'Errors (' + validationErrors.length + ')'"
    [buttonType]="'error'"
    [avanoErrorsPopover]="validationErrors"
    (errorSourceLinkClicked)="resumeEditing(currentContext.ref)"
  ></button>
</ng-template>
